import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useGetRevenueGraph, useGetUserGraph, useGetSubscriptionGraph, useGetDashboardStats } from "../../api/hooks/useDashboard";
import DashboardChart from "../../features/dashboard/components/DashboardChart";


const Dashboard = () => {
  const navigate = useNavigate();
  const [revenueType, setRevenueType] = useState<number>(1); // 1 = day, 2 = week, 3 = month, 4 = year
  const [activityType, setActivityType] = useState<number>(1); // 1 = day, 2 = week, 3 = month, 4 = year
  const [subscriptionType, setSubscriptionType] = useState<number>(1); // 1 = day, 2 = week, 3 = month, 4 = year

  const { data: statsData, isLoading: isLoadingStats } = useGetDashboardStats();
  const { data: revenueGraphData, isLoading: isLoadingRevenue } = useGetRevenueGraph({ type: revenueType });
  const { data: userGraphData, isLoading: isLoadingUserGraph } = useGetUserGraph({ type: activityType });
  const { data: subscriptionGraphData, isLoading: isLoadingSubscriptionGraph } = useGetSubscriptionGraph({ type: subscriptionType });

  const stats = statsData?.data || {
    users: 0,
    workoutCompletionRates: 0,
    subscriptionConversions: 0,
    programEngagement: 0,
    communityActivity: 0,
    emailOptIns: 0
  };

  const revenueChartData = revenueGraphData?.data?.map((item: any) => ({
    name: item.name,
    value: item.value || 0
  })) || [];

  const activityChartData = userGraphData?.data?.map((item: any) => ({
    name: item.name,
    value: item.value || 0
  })) || [];

  const subscriptionChartData = subscriptionGraphData?.data?.map((item: any) => ({
    name: item.name,
    value: item.value || 0
  })) || [];

  if (isLoadingStats) {
    return <div className="main_title">
      <h1>Loading dashboard...</h1>
    </div>;
  }

  return (
    <>
      <div className="main_title">
        <h1>Dashboard</h1>
      </div>

      <div className="stats_boxes gap_m">
        <div className="cards" onClick={() => navigate("/manage-users")}>
          <figure>
            <img src="/static/images/user_icon.svg" alt="Users" />
          </figure>
          <h2>{stats.users}</h2>
          <p>Active users</p>
        </div>

        <div className="cards" onClick={() => navigate("/manage-users")}>
          <figure>
            <img src="/static/images/user_icon.svg" alt="Active Users" />
          </figure>
          <h2>{stats.workoutCompletionRates}%</h2>
          <p>Workout completion rates</p>
        </div>

        <div className="cards" onClick={() => navigate("")}>
          <figure>
            <img src="/static/images/offer_icon.svg" alt="Revenue" />
          </figure>
          <h2>{stats.subscriptionConversions}</h2>
          <p>Subscription conversions</p>
        </div>
        <div className="cards" onClick={() => navigate("")}>
          <figure>
            <img src="/static/images/order.svg" alt="Programs" />
          </figure>
          <h2>{stats.programEngagement}</h2>
          <p>Program engagement</p>
        </div>
        <div className="cards" onClick={() => navigate("")}>
          <figure>
            <img src="/static/images/order.svg" alt="Community" />
          </figure>
          <h2>{stats.communityActivity}</h2>
          <p>Community activity</p>
        </div>
        {/* <div className="cards" onClick={() => navigate("")}>
          <figure>
            <img src="/static/images/order.svg" alt="Email" />
          </figure>
          <h2>{stats.emailOptIns}</h2>
          <p>Email opt-ins (via MailerLite)</p>
        </div> */}
      </div>
      <div className="grid_sc gap_m">
        <DashboardChart
          title="Active Users"
          currentType={activityType}
          onTypeChange={setActivityType}
          isLoading={isLoadingUserGraph}
          data={activityChartData}
          noDataMessage="No activity data available"
        />

        <DashboardChart
          title="Total Revenue"
          currentType={revenueType}
          onTypeChange={setRevenueType}
          isLoading={isLoadingRevenue}
          data={revenueChartData}
          noDataMessage="No revenue data available"
        />

        <DashboardChart
          title="Subscription Graph"
          currentType={subscriptionType}
          onTypeChange={setSubscriptionType}
          isLoading={isLoadingSubscriptionGraph}
          data={subscriptionChartData}
          noDataMessage="No subscription data available"
        />
      </div>
    </>
  );
};

export default Dashboard;